import {Component, HostListener, OnInit} from "@angular/core";
import {PageService} from "../../service/page/page.service";
import {PageSlider2Item} from "../../service/page/page";
import * as moment from "moment";

@Component({
  selector: 'app-top-banner',
  templateUrl: './top-banner.component.html',
  styleUrls: ['./top-banner.component.scss'],
  providers: [PageService]
})
export class TopBannerComponent implements OnInit {
  isShow: boolean = false;
  isMobile: boolean = false;
  banner: PageSlider2Item;

  constructor(private pageService: PageService) {
    this.isMobile = (window.innerWidth < 768);

    pageService.getBanner().subscribe(
      banner => {
        this.banner = banner;
        this.isShow = moment().isBetween(banner.startTime, banner.endTime)
      }
    );
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
    }
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/home/top-banner/top-banner.component.ts